import { Box, Typography, styled } from "@mui/material";

export interface TopbarTitleProps {
    ident: string;
    title: string;
}

const monoFontStack = "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace";

const Root = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "baseline",
    gap: theme.spacing(1.25),
    minWidth: 0,
}));

const Ident = styled("span")(({ theme }) => ({
    fontFamily: monoFontStack,
    fontSize: "0.75rem",
    fontWeight: 700,
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.info.light,
    padding: "4px 10px",
    borderRadius: 999,
    letterSpacing: "0.02em",
    flexShrink: 0,
}));

const Dash = styled("span")(({ theme }) => ({
    color: theme.palette.text.disabled,
    fontWeight: 400,
}));

export const TopbarTitle = ({ ident, title }: TopbarTitleProps) => {
    return (
        <Root>
            <Ident>{ident}</Ident>
            <Dash>·</Dash>
            <Typography
                variant="body1"
                sx={{
                    fontWeight: 600,
                    color: "text.primary",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {title}
            </Typography>
        </Root>
    );
};
